// Main Menu: Mobile Toggle + Hover (per-item timeouts)
document.addEventListener("DOMContentLoaded", function () {
	const toggle = document.querySelector(".mobile-menu-toggle");
	const header = document.querySelector(".site-header");

	if (toggle && header) {
		toggle.addEventListener("click", () => {
			header.classList.toggle("menu-state--active");
			header.classList.toggle("menu-state--inactive");
			document.body.classList.toggle("scroll-lock");
		});
	}

	const breakpoint = 992;
	const menuItems = document.querySelectorAll(".main-menu__item");
	const mobileMenuTitleContainer = document.querySelector(
		".mobile-sub-menu-header"
	);
	const mobileMenuTitleText = document.querySelector(
		".mobile-sub-menu-header__text"
	);

	let activeItem = null;

	// Per-item hide timers
	const hideTimers = new WeakMap();

	function clearHideTimer(item) {
		const t = hideTimers.get(item);
		if (t) {
			clearTimeout(t);
			hideTimers.delete(item);
		}
	}

	function deactivateItem(item) {
		item.classList.remove("state--active");
		item.classList.add("state--inactive");
	}

	function activateItem(item) {
		item.classList.add("state--active");
		item.classList.remove("state--inactive");
	}

	function deactivateAllExcept(current) {
		menuItems.forEach((i) => {
			if (i !== current) {
				clearHideTimer(i);
				deactivateItem(i);
			}
		});
	}

	menuItems.forEach((item) => {
		const hasSub =
			item.classList.contains("has-sub-menu") ||
			item.classList.contains("has-mega-menu");
		if (!hasSub) return;

		const title = item.dataset.menuTitle || "";
		const subMenu = item.querySelector(".sub-menu, .mega-menu");
		const link = item.querySelector("a");

		// === Desktop hover behaviour ===
		item.addEventListener("mouseenter", () => {
			if (window.innerWidth >= breakpoint) {
				// Only this item's timer should be cleared; don't cancel others
				clearHideTimer(item);
				// Ensure only one active at a time on desktop
				deactivateAllExcept(item);
				activateItem(item);
			}
		});

		item.addEventListener("mouseleave", () => {
			if (window.innerWidth >= breakpoint) {
				// Schedule hide for THIS item only
				clearHideTimer(item);
				const t = setTimeout(() => {
					deactivateItem(item);
					hideTimers.delete(item);
				}, 200);
				hideTimers.set(item, t);
			}
		});

		if (subMenu) {
			subMenu.addEventListener("mouseenter", () => {
				if (window.innerWidth >= breakpoint) {
					clearHideTimer(item);
				}
			});
			subMenu.addEventListener("mouseleave", () => {
				if (window.innerWidth >= breakpoint) {
					clearHideTimer(item);
					const t = setTimeout(() => {
						deactivateItem(item);
						hideTimers.delete(item);
					}, 200);
					hideTimers.set(item, t);
				}
			});
		}

		// === Mobile click behaviour ===
		if (link) {
			link.addEventListener("click", (e) => {
				if (window.innerWidth < breakpoint) {
					e.preventDefault();
					const isActive = item.classList.contains("state--active");

					menuItems.forEach((i) => {
						clearHideTimer(i);
						deactivateItem(i);
					});

					if (!isActive) {
						activateItem(item);
						activeItem = item;

						if (mobileMenuTitleText)
							mobileMenuTitleText.textContent = title;
						if (header) {
							header.classList.add("sub-menu-state--active");
							header.classList.remove("sub-menu-state--inactive");
						}
					} else {
						activeItem = null;
						if (header) {
							header.classList.remove("sub-menu-state--active");
							header.classList.add("sub-menu-state--inactive");
						}
					}
				}
			});
		}
	});

	// Mobile sub-menu header back button
	if (mobileMenuTitleContainer) {
		mobileMenuTitleContainer.addEventListener("click", () => {
			if (activeItem) {
				clearHideTimer(activeItem);
				deactivateItem(activeItem);
				activeItem = null;
				if (header) {
					header.classList.remove("sub-menu-state--active");
					header.classList.add("sub-menu-state--inactive");
				}
			}
		});
	}

	// On resize to desktop, clear any mobile-open state
	window.addEventListener("resize", () => {
		if (window.innerWidth >= breakpoint && activeItem) {
			clearHideTimer(activeItem);
			deactivateItem(activeItem);
			activeItem = null;
			if (header) {
				header.classList.remove("sub-menu-state--active");
				header.classList.add("sub-menu-state--inactive");
			}
		}
	});
});
